import styled, { css } from 'react-emotion';

export default css`
	display: block;
	width: 100%;
	overflow: hidden;

	path {
		fill: #e6e6e6;
		fill-opacity: 1;
		stroke: #ffffff;

		&.active {
			cursor: pointer;
			fill: #95b3c3;
			transition: fill-opacity 300ms;

			&:hover {
				fill-opacity: 0.5;
			}
		}
		
		&.active.selected {
				fill-opacity: 0.5;

			&:hover {
				fill-opacity: 0.5;
			}
		}
	}

	text {
		font-size: 0.875rem;
	}

	@media (max-width: 480px) {
		display: none;
	}
`;

export const regionalMap = css`
	@media (min-width: 375px) and (max-width: 480px) {
		display: block;
		margin-bottom: 15px;
	}
`;

export const municipalMap = css`
	path {
		fill: white;
		stroke: #222;
		stroke-width: 0.5px;
	}

	circle {
		cursor: pointer;
		fill: #e6e6e6;
		stroke: #222;
		stroke-width: 0.5px;

		&:hover {
			stroke: #0485a5;
			stroke-width: 1px;
		}
	}
`;

export const WidgetTitle = styled.div`
	color: #fff;
	font-size: 1.5rem;
	font-weight: bold;
	margin-bottom: 1rem;
	text-align: left;
`

export const WidgetLink = styled.a`
	background: #fff;
	border-radius: 2px;
	color: ${props => props.theme.color};
	display: inline-block;
	font-size: 0.875rem;
	line-height: 2;
	padding: 0 0.75rem;
	margin: 1rem auto 0;
	text-decoration: none;
`
